import apiService from './apiService';

interface LoginResponse {
  user: any;
  accessToken: string;
  refreshToken: string;
}

interface RegisterResponse {
  message: string;
  email: string;
  emailVerified: boolean;
}

interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    return apiService.post('/auth/login', { email, password });
  },

  async register(email: string, password: string, name?: string): Promise<RegisterResponse> {
    return apiService.post('/auth/register', { email, password, name });
  },

  async logout(): Promise<void> {
    return apiService.post('/auth/logout');
  },

  async refreshToken(refreshToken: string): Promise<RefreshTokenResponse> {
    return apiService.post('/auth/refresh', { refreshToken });
  },

  async getCurrentUser(): Promise<any> {
    return apiService.get('/auth/me');
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    return apiService.post('/auth/forgot-password', { email });
  },

  async resetPassword(token: string, password: string): Promise<{ message: string }> {
    return apiService.post('/auth/reset-password', { token, password });
  },

  async verifyEmail(token: string): Promise<{ message: string }> {
    return apiService.post('/auth/verify-email', { token });
  },

  async resendVerificationEmail(email: string): Promise<{ message: string; email?: string; emailVerified?: boolean; isOAuthAccount?: boolean }> {
    return apiService.post('/auth/resend-verification', { email });
  },

  /**
   * Google OAuth login
   * @param idToken - Google ID token from Google Sign-In
   */
  async googleOAuth(idToken: string): Promise<LoginResponse> {
    return apiService.post('/auth/oauth/google', { id_token: idToken });
  },
};
